module.exports = __webpack_public_path__ + "static/media/ecom.786a1911.png";